import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { KonamiService } from '../../service/konami.service';

@Component({
  selector: 'app-konami',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule, FormsModule],
  templateUrl: './konami.component.html',
  styleUrl: './konami.component.less'
})
export class KonamiComponent {
  dialog = inject(MatDialog);
  konamiService = inject(KonamiService);
  closeDialog(): void {
    this.dialog.closeAll();
  }
}
